import { put } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

// get
function updateReadNotification (pNotificationId) {
    const URI = `${BASE_URL}/api/notification/${pNotificationId}/update-read`
    return put(URI, null ,{ headers })
}

export { updateReadNotification }